import { useMemo } from 'react';


type Return = {
  hasEntryToday: boolean
  entryToday?: Programs.StepEntry
}

export const useEntryToday = (enrollment: Programs.Enrollment): Return => {
  const entryToday = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);

    const sortedByDate = enrollment.stepEntries.sort((a, b) => {
      const aCompletedDate = new Date(a.completedAt);
      const bCompletedDate = new Date(b.completedAt);

      return bCompletedDate.valueOf() - aCompletedDate.valueOf();
    });

    return sortedByDate.find(
      e => new Date(e.completedAt).toISOString().slice(0, 10) === today,
    );
  }, [enrollment.stepEntries]);

  return {
    hasEntryToday: enrollment.program.allowSameDayEntries ? false : Boolean(entryToday),
    entryToday,
  };
};